import request from '@/utils/request'
const apiPreQuest = '/admin'
/**
 * 管理员信息
 */
export const adminInfoApi = data => {
  return request({
    url: `${apiPreQuest}Info`,
    method: 'POST',
    data
  })
}

/**
 * 所有数据
 * @param {*} data
 * @returns
 */
export const allDataApi = data => {
  return request({
    url: `${apiPreQuest}All`,
    method: 'POST',
    data
  })
}

/**
 * 列表数据
 * @param data
 * @returns {*}
 */
export const indexApi = data => {
  return request({
    url: `${apiPreQuest}Index`,
    method: 'POST',
    data
  })
}

/**
 * 新增数据
 * @param data
 * @returns {*}
 */
export const addApi = data => {
  return request({
    url: `${apiPreQuest}Add`,
    method: 'POST',
    data
  })
}

/**
 * 编辑数据
 * @param data
 * @returns {*}
 */
export const editApi = data => {
  return request({
    url: `${apiPreQuest}Edit`,
    method: 'POST',
    data
  })
}

/**
 * 删除数据
 * @param data
 * @returns {*}
 */
export const delApi = data => {
  return request({
    url: `${apiPreQuest}Del`,
    method: 'POST',
    data
  })
}

/**
 * 详情数据
 * @param data
 * @returns {*}
 */
export const detailApi = data => {
  return request({
    url: `${apiPreQuest}Detail`,
    method: 'POST',
    data
  })
}

/**
 * 改变数据状态
 * @param data
 * @returns {*}
 */
export const changeStatusApi = data => {
  return request({
    url: `${apiPreQuest}ChangeStatus`,
    method: 'POST',
    data
  })
}

export const adminMainApi = (data) => {
  return request({
    url: 'adminMain',
    method: 'POST',
    data
  })
}

/**
 * 平台管理员
 * @param {*} data
 * @returns
 */
export const adminPlatformAdminApi = (data) => {
  return request({
    url: 'adminPlatformAdmin',
    method: 'POST',
    data
  })
}
/**
 *  修改密码
 * @param {*} data
 * @returns
 */
export const adminChangePasswordApi = (data) => {
  return request({
    url: 'adminChangePassword',
    method: 'POST',
    data
  })
}
